import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import { createStore, errorReducer, loadingReducer } from '@a1/core';

import ScrollToTop from './components/ScrollToTop';
import Layout from './components/layout';
import { processReducer } from './reducer/processReducer';

const reducers = {
  process: processReducer,
  loading: loadingReducer,
  errors: errorReducer,
};

/* TO DO QUERY STRING NUMBER  TO DO  */

const App = () => {
  const store = createStore({}, reducers);

  return (
    <Provider store={store}>
      <Router>
        <ScrollToTop />
        <Layout />
      </Router>
    </Provider>
  );
};

export default App;
